<template>
  <div class="tabs">
    <span v-for="item in tabs"
      :key="item.value"
      :class="{'active': currentItem===item.value}"
      @click="handleClick(item)">
      {{item.label}}
    </span>
  </div>
</template>

<script>
import config from '@/utils/chart/config'

export default {
  data() {
    return {
      tabs: [
        {value: 'v', label: '成交量'},
        {value: 'MACD', label: 'MACD'},
        {value: 'KDJ', label: 'KDJ'},
        {value: 'RSI', label: 'RSI'},
        {value: 'BIAS', label: 'BIAS'},
        {value: 'CCI', label: 'CCI'},
        {value: 'BOLL', label: 'BOLL'},
        {value: 'OBV', label: 'OBV'}
      ],
      currentItem: 'v'
    }
  },
  methods: {
    handleClick({value, label}) {
      if(value === this.currentItem) return
      this.currentItem = value
      this.$emit('indicatorMutated', value)
    }
  },
}
</script>

<style lang="stylus" scoped>
  .tabs {
    display flex
    flex: none
    overflow-x: auto;
    font-size: .14rem;
    color: #162641;
    background-color: white
    padding 0 .04rem
  }
  .tabs span {
    margin-right: .33rem;
    text-align: center;
    white-space: nowrap
  }
  .active {
    color: #F43737;
    border-bottom: 2px solid #F43737;
  }
</style>